// Data for SEO-friendly product & city landing pages.
export const MACHINES = {
  "refuel-core": {
    slug: "refuel-core",
    name: "Refuel CORE",
    tag: "Snack & Beverage",
    keyword: "snacks vending machine India",
    metaTitle: "Refuel CORE — Snacks & Beverage Vending Machine in India | Thecoventures",
    metaDescription:
      "Buy the Refuel CORE snacks and beverage vending machine for offices in India. HD touch, UPI + card, precision cooling, up to 300 SKUs. Pan-India AMC, 98% uptime SLA. Get a free quote.",
    h1: "Refuel CORE — Snacks & Beverage Vending Machine",
    subh:
      "The flagship snacks vending machine for Indian offices. Cashless payments, IoT telemetry, up to 300 SKUs.",
    heroImg:
      "https://vend-modern.preview.emergentagent.com/api/static/refuel_core_hero.png",
    brochureKey: "core",
    highlights: [
      "Up to 300 items across snacks + chilled beverages",
      "HD touchscreen with intuitive product browsing",
      "UPI, cards and wallets supported (RFID / prepaid card available as a chargeable add-on)",
      "Precision cooling for beverages & dairy",
      "Cloud telemetry: stock, sales and health in real-time",
      "Pan-India AMC + 98% uptime SLA",
    ],
    specs: [
      ["Categories", "Snacks, chocolates, chilled beverages"],
      ["Payments", "UPI / Card / Wallet (RFID / prepaid card — optional add-on)"],
      ["Capacity", "Up to 300 items"],
      ["Cooling", "Precision — chilled zone"],
      ["Display", "HD touchscreen"],
      ["Connectivity", "4G / Wi-Fi, cloud dashboard"],
    ],
  },
  "refuel-lite": {
    slug: "refuel-lite",
    name: "Refuel LITE",
    tag: "Compact Cashless",
    keyword: "compact vending machine office India",
    metaTitle: "Refuel LITE — Compact Cashless Vending Machine India | Thecoventures",
    metaDescription:
      "Refuel LITE compact cashless vending machine for small Indian offices. UPI, cards, wallets. Ideal for teams under 100. Get a free quote from Thecoventures.",
    h1: "Refuel LITE — Compact Cashless Vending Machine",
    subh: "The right-sized vending machine for small teams. Cashless-first, plug-and-play install.",
    heroImg:
      "https://vend-modern.preview.emergentagent.com/api/static/refuel_core_hero.png",
    brochureKey: "lite",
    highlights: [
      "Compact footprint — fits any pantry corner",
      "UPI, card & wallet payments out of the box",
      "Ideal for offices of 25–100 employees",
      "Cloud stock alerts & remote diagnostics",
      "Optional AMC for zero-downtime",
    ],
    specs: [
      ["Categories", "Snacks, cold drinks"],
      ["Payments", "UPI / Card / Wallet (RFID / prepaid card — optional add-on)"],
      ["Capacity", "Up to 180 items"],
      ["Connectivity", "4G / Wi-Fi"],
    ],
  },
  "refuel-max": {
    slug: "refuel-max",
    name: "Refuel MAX",
    tag: "High-volume",
    keyword: "high volume vending machine factory hospital",
    metaTitle: "Refuel MAX — High-Volume Vending Machine India | Thecoventures",
    metaDescription:
      "Refuel MAX high-volume vending machine for factories, hospitals and campuses in India. 400+ SKUs, 21-inch touchscreen, cashless payments. Pan-India service.",
    h1: "Refuel MAX — High-Volume Vending Machine",
    subh:
      "For high-footfall factories, hospitals, campuses and retail. 400+ SKUs and a 21-inch touchscreen for a premium in-store feel.",
    heroImg:
      "https://vend-modern.preview.emergentagent.com/api/static/refuel_core_hero.png",
    brochureKey: "max",
    highlights: [
      "400+ SKUs, deep pockets, mixed snack & beverage",
      "21-inch HD touchscreen for a rich merchandising experience",
      "Reinforced build for factory / retail environments",
      "Priority AMC with fast-response spares",
      "Ideal for footfall of 500+ per day",
    ],
    specs: [
      ["Categories", "Snacks, cold drinks, energy bars, meals"],
      ["Payments", "UPI / Card / Wallet (RFID / prepaid card — optional add-on)"],
      ["Capacity", "400+ items"],
      ["Display", "21-inch HD touchscreen"],
      ["Connectivity", "4G / Wi-Fi"],
    ],
  },
  "refuel-safe": {
    slug: "refuel-safe",
    name: "Refuel SAFE",
    tag: "PPE Dispenser",
    keyword: "PPE vending machine India factory hospital",
    metaTitle: "Refuel SAFE — PPE Vending Machine India | Thecoventures",
    metaDescription:
      "Refuel SAFE PPE and safety vending machine for factories, hospitals and labs in India. Auditable issuance, RFID / employee ID authentication, Sure-Vend technology.",
    h1: "Refuel SAFE — PPE & Safety Vending Machine",
    subh:
      "Gloves, masks, glasses and consumables dispensed with auditable issuance. Built for Indian factories, hospitals and labs.",
    heroImg:
      "https://vend-modern.preview.emergentagent.com/api/static/refuel_core_hero.png",
    brochureKey: "safe",
    highlights: [
      "Auditable per-employee issuance",
      "Sure-Vend tech — dispenses only when confirmed",
      "RFID / employee-ID authentication",
      "Reduces shrinkage on high-value PPE",
      "Suits ISO / EHS compliance audits",
    ],
    specs: [
      ["Categories", "Gloves, masks, glasses, ear-plugs, ..."],
      ["Auth", "RFID / Employee ID / QR"],
      ["Capacity", "Up to 240 SKU pockets"],
      ["Compliance", "Audit logs exportable"],
    ],
  },
};

export const CITIES = {
  vadodara: {
    slug: "vadodara",
    name: "Vadodara",
    state: "Gujarat",
    keyword: "vending machine Vadodara",
    metaTitle: "Vending Machine in Vadodara — Snacks, PPE & Coffee | Thecoventures",
    metaDescription:
      "Buy vending machines in Vadodara from Thecoventures — snacks, beverage, coffee and PPE machines for corporates, factories and hospitals. Local install, on-site AMC.",
    highlights: [
      "Local install and same-city service response",
      "Corporate parks: Alkapuri, Race Course, Sayajigunj",
      "Factory clusters: Padra, Halol, Waghodia",
    ],
  },
  ahmedabad: {
    slug: "ahmedabad",
    name: "Ahmedabad",
    state: "Gujarat",
    keyword: "vending machine Ahmedabad",
    metaTitle: "Vending Machine in Ahmedabad — Office, PPE & Snacks | Thecoventures",
    metaDescription:
      "Vending machine dealer in Ahmedabad. Snacks, beverage, coffee, PPE and stationery vending for offices, IT parks and hospitals. AMC + pan-India service network.",
    highlights: [
      "GIFT City / SG Highway IT corridor coverage",
      "Chandkheda, Naroda and Vatva factory zones",
      "Hospital & campus deployments across the city",
    ],
  },
  mumbai: {
    slug: "mumbai",
    name: "Mumbai",
    state: "Maharashtra",
    keyword: "vending machine Mumbai",
    metaTitle: "Vending Machine in Mumbai — Corporate, Factory & Hospital | Thecoventures",
    metaDescription:
      "Buy vending machines in Mumbai — snacks, coffee, beverage and PPE for BKC, Andheri, Navi Mumbai. Cashless UPI, 98% uptime SLA, pan-India AMC.",
    highlights: [
      "BKC, Andheri East, Powai & Lower Parel offices",
      "Navi Mumbai and MIDC factory clusters",
      "24×7 support desk with fast on-site response",
    ],
  },
  bangalore: {
    slug: "bangalore",
    name: "Bangalore",
    state: "Karnataka",
    keyword: "vending machine Bangalore",
    metaTitle: "Vending Machine in Bangalore — IT Parks & Startups | Thecoventures",
    metaDescription:
      "Cashless UPI vending machines for Bangalore offices, IT parks and startups. Snacks, coffee, beverage, PPE. Pan-India AMC and remote telemetry.",
    highlights: [
      "Whitefield, ORR, Electronic City IT campuses",
      "Startups in Koramangala & Indiranagar",
      "Manyata Tech Park + Manufacturing units in Peenya",
    ],
  },
  pune: {
    slug: "pune",
    name: "Pune",
    state: "Maharashtra",
    keyword: "vending machine Pune",
    metaTitle: "Vending Machine in Pune — Offices, MIDC & Hospitals | Thecoventures",
    metaDescription:
      "Vending machine supplier in Pune — snacks, beverage, PPE and coffee. Hinjewadi, Kharadi, Chakan MIDC coverage with local AMC.",
    highlights: [
      "Hinjewadi Phase 1/2/3 IT parks",
      "Kharadi and EON Free Zone",
      "Chakan / Talegaon MIDC factory belts",
    ],
  },
  delhi: {
    slug: "delhi",
    name: "Delhi NCR",
    state: "Delhi",
    keyword: "vending machine Delhi NCR",
    metaTitle: "Vending Machine in Delhi NCR — Gurgaon, Noida | Thecoventures",
    metaDescription:
      "Cashless vending machines for Delhi NCR — Gurgaon, Noida, Faridabad. Snacks, coffee, beverage & PPE for corporates and factories.",
    highlights: [
      "Cyber City / Golf Course Road Gurgaon offices",
      "Noida Sector 62 / 125 IT corridor",
      "Faridabad and Manesar factory zones",
    ],
  },
  hyderabad: {
    slug: "hyderabad",
    name: "Hyderabad",
    state: "Telangana",
    keyword: "vending machine Hyderabad",
    metaTitle: "Vending Machine in Hyderabad — HITEC City & Gachibowli | Thecoventures",
    metaDescription:
      "Vending machine dealer in Hyderabad — HITEC City, Gachibowli, Financial District. Snacks, beverage, PPE and stationery vending. Local AMC.",
    highlights: [
      "HITEC City & Gachibowli IT campuses",
      "Financial District and Nanakramguda hubs",
      "Sanathnagar / Balanagar industrial zones",
    ],
  },
};

export const FAQS = [
  {
    q: "How much does a snacks vending machine cost in India?",
    a: "The Refuel range starts from ₹1.5 lakhs (transport charges are extra). Final pricing depends on the configuration — cooling zones, screen size, capacity and software plan. Share your site details and we will send a written quote within 24 hours.",
  },
  {
    q: "Can I rent a vending machine instead of buying it?",
    a: "We primarily sell vending machines outright — you own the asset, keep the full margin and there are no monthly lock-ins. Rentals are available only for verified corporate customers, subject to site survey and minimum tenure.",
  },
  {
    q: "Which brands can be sold from a Thecoventures vending machine?",
    a: "You can stock any Indian FMCG brand — Lay's, Kurkure, Bingo, Parle-G, Hide & Seek, Frooti, Real, Thums Up, Limca, Bisleri, Nescafé, Maggi and more. In line with the current healthy-snacking trend, you can also keep protein bars, oats bars, dry-fruit mixes, muesli cups, cold-pressed juices, low-sugar drinks and other healthy items. We help you plan the product mix based on your footfall and audience.",
  },
  {
    q: "Do the machines accept UPI and cards?",
    a: "Yes. Every Refuel machine ships cashless-ready with UPI, QR, cards and wallets built in. RFID / prepaid card / employee-card based dispensing is additionally available on a chargeable basis.",
  },
  {
    q: "Where in India do you install and service vending machines?",
    a: "We install pan-India and maintain a technician network across major cities including Vadodara, Ahmedabad, Mumbai, Pune, Bangalore, Delhi NCR, Hyderabad, Chennai and Kolkata.",
  },
  {
    q: "What is the uptime SLA on your vending machines?",
    a: "Our AMC customers get a 98% uptime SLA backed by remote telemetry, planned refills and a fast-response technician network.",
  },
  {
    q: "Can I get a PPE vending machine for my factory or hospital?",
    a: "Yes. The Refuel SAFE dispenses PPE (gloves, masks, glasses, ear-plugs, consumables) with employee-ID or RFID authentication and full audit logs — used in factories, hospitals and labs for compliance.",
  },
  {
    q: "Do you provide AMC (Annual Maintenance Contract)?",
    a: "Yes. AMC includes scheduled visits, remote diagnostics, spare-parts, priority response and a 98% uptime SLA. Available for machines you buy from us as well as select existing machines.",
  },
  {
    q: "How long does it take to install a vending machine?",
    a: "Delivery timelines depend on your location and whether the requested machine configuration is in ready stock — typically 7–14 business days. Payment-gateway onboarding usually takes an additional 15–20 days, provided all documents are shared as per the payment gateway's policy. Any applicable charges will be mentioned upfront in the agreement.",
  },
  {
    q: "Where is Thecoventures based?",
    a: "Thecoventures is headquartered in Vadodara, Gujarat, India with pan-India installations and a service partner network across major Indian cities.",
  },
];
